import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { latLng, MapOptions, tileLayer } from 'leaflet';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-trip-info',
  templateUrl: './trip-info.component.html',
  styleUrls: ['./trip-info.component.scss']
})
export class TripInfoComponent extends NgbActiveModal implements OnInit {
  public leafletOptions: MapOptions;
  public layers: any[];

  constructor(
    private cd: ChangeDetectorRef,
    public activeModal: NgbActiveModal,
    private appConfig: AppConfig
  ) {
    super();
  }

  ngOnInit() {
    let tileLayerOptions = {
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.leafletOptions = {
      layers: [
        // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions)
        this.appConfig.getTileLayer()
      ],
      zoom: 14,
      center: latLng(50.848656786354994, 4.349341392517091),
      zoomControl: false
    };
    this.cd.detectChanges();
  }

}
